<template>
    <property-search-module
        v-if="loadSearchComponents"
        :property-search-route="propertySearchRoute"
        :property-details-route="propertyDetailsRoute"
        :search-config="{
            apiPath: 'elasticsearch'
        }"
        :default-location-overwrite="defaultLocation"
        :primary-filters="[
            'price',
            'beds',
            'sale',
        ]"
        :active-action-buttons="activeActionButtons"
        :favorite-option-enabled="false"
        :tab-display="false"
        :filterable="filterable"
        :toggleable="toggleable"
    />
</template>

<script>
    import './PropertySearch.scss';
    const PropertySearchModule = () => import ('@milestoneslabs/milestones-property-search');
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import {BUY_LANDING_PAGE_DATA} from "../../pages/LandingPage/Buy/Buy.vue";
    import {mapGetters} from 'vuex';
    import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
    import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
    import LandingPageBuySectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageBuySectionAppResource";

    export default {
        name: 'PropertySearch',

        components: {
            PropertySearchModule,
        },

        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
            filterable: {
                type: Boolean,
                default: true,
            },
            toggleable: {
                type: Boolean,
                default: false,
            },
            propertySearchRoute: {
                type: [String, Object],
                default:() => {
                    return {
                        name: 'property.search'
                    };
                },
            },
            propertyDetailsRoute: {
                type: [String, Object],
                default:() => {
                    return {
                        name: 'property.details.page'
                    };
                },
            },
            isMortgageAvailable: {
                type: Boolean,
                default: false,
            },
            hasServiceProviders: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                landingPageUuid: window.landingPageUuid,
                buySection: new LandingPageBuySectionAppResource(),
            };
        },

        computed: {
            activeActionButtons(){
                let items = [];
                if (this.buySection.hasTour) {
                    items.push('tour');
                }
                if (this.buySection.hasOffer) {
                    items.push('offer');
                }
                if (
                    this.buySection.hasFinance &&
                    this.isMortgageAvailable &&
                    this.hasServiceProviders
                ) {
                    items.push('finance');
                }
                if (this.buySection.hasTrade) {
                    items.push('trade');
                }

                return items;
            },

            defaultLocation() {
                return (this.getDefaultMapCoordinates || '').split('|').map((number) => parseFloat(number));
            },

            loadSearchComponents() {
                if (this.defaultLocation.length > 1 && this.getCurrentProjectMlsId) {
                    return true;
                }

                let routePath = this.$route.path || '',
                    routeName = this.$route.name || '';
                return routePath.lastIndexOf('/property-details') > -1 ||
                    routeName.lastIndexOf('property') > -1 &&
                    routeName.lastIndexOf('details') > -1;
            },

            ...mapGetters([
                'getDefaultMapCoordinates',
                'getCurrentProjectMlsId',
            ])
        },
        async created() {
            this.$bus.$emit(BUY_LANDING_PAGE_DATA, this.landingPage);

            await this.fetchBuySection();
        },
        methods: {
            async fetchBuySection() {
                if (!this.landingPageUuid) {
                    return;
                }

                try {
                    let search = new AppResourceSearch('landing-page-buy-section');
                    search.setSearchData({
                        filter: new ApiFilter({
                            params: {
                                landingPageUuid: this.landingPageUuid
                            }
                        })
                    }, false);

                    await search.search();

                    if (search.appResourceCollection.isNotEmpty) {
                        this.buySection = search.appResourceCollection.getFirst();
                    }

                } catch (e) {
                    console.warn(e);
                    this.showNotification({
                        message: `Something went wrong while fetching buy section! Please try again later!`,
                        type: 'error',
                    });
                }
            },
        }
    };
</script>
